<template>
    <div class="account">
        <div class="action-header">
            <div class="action-header__title">
                Overview
            </div>
            <div class="action-header__date-picker">
                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" @change="getChartData" range-separator=" " v-model="time" :shortcuts="shortcuts" :formatter="customFormat" range format="DD/MM/YYYY"></vue-date-picker>
            </div>
        </div>
        <div class="account__graph-container">
            <div class="account__cards-container" v-if="accountCards && accountCards.length">
                <div v-for="card in accountCards" v-on:click="showGraph(card.id)" :key="card.id"
                     v-bind:id="'account-card-'+card.id" v-bind:class="graphActiveCards.includes(card.id) ? card.id : ''" class="account__card card">
                    <div class="card__title">{{card.title}}</div>
                    <div class="card__value">{{card.value}}</div>
                </div>
            </div>
            <div class="account__graph-wrapper">
                <div class="graph-filters">
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'day' }" @click="graph_type = 'day'" href="#">Daily</a>
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'week' }" @click="graph_type = 'week'" href="#">Weekly</a>
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'month' }" @click="graph_type = 'month'" href="#">Monthly</a>
                </div>
                <div class="account__graph">
                    <div>
                        <line-chart :styles="{height: '270px', position: 'relative'}" :chart-data="filteredChartData" :options="chartOptions"></line-chart>
                        <div class="graph-footer">
                            <div class="">{{this.leftDate}}</div>
                            <div class="">{{this.rightDate}}</div>
                        </div>
                    </div>
                    <div v-show="filteredChartData.datasets.length === 0" class="account__graph-no-data">No data to display</div>
                </div>
            </div>
        </div>
        <template v-if="isLoading" >
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                </svg>
            </div>
        </template>
        <template v-else-if="tableDataExist">
            <div class="account__actions actions">
                <div class="actions__search-container">
                    <input @input="getAccountData(true)" class="actions__search-input" v-model="filter.query" type="text" placeholder="Search by Google Ads ID or name"/>
                    <inline-svg
                        class="actions__search-icon"
                        src="/images/search.svg" aria-label="search">
                    </inline-svg>
                    <inline-svg
                        v-show="filter.query"
                        @click="clearSearch()"
                        class="clear-search"
                        src="/images/clear.svg" aria-label="clear">
                    </inline-svg>
                </div>
                <div class="actions__add-filter__wrapper">
                    <data-filter @filterApply='applyFilter' v-bind:filtersInit="filtersDataComponent"></data-filter>
                </div>
                <!--button style="visibility: hidden;" type="button" class="actions__add-account">Add Filter</button-->

<!--                <div v-if="['active', 'trialing', 'past_due'].includes(stripeInfo.subscription_status)"
                     v-on:click="showModal('connect-unavailable-modal')"
                     class="actions__add-account"
                     style="background-color: #2280fe;">

                    <inline-svg src="/images/plus.svg" class="s-20 fill-white mb-1" aria-label="add"></inline-svg>
                    &nbsp;ADD ACCOUNT
                </div>-->
                <a v-if="['active', 'trialing', 'past_due'].includes(stripeInfo.subscription_status)"
                   href="/setup/connectGoogleAds"
                   class="actions__add-account"
                   style="background-color: #2280fe;"
                >
                    <inline-svg src="/images/plus.svg" class="s-20 fill-white mb-1" aria-label="add"></inline-svg>
                    &nbsp;ADD ACCOUNT
                </a>
            </div>

            <div class="account__table main-table">
                <table class="main-table__wrapper">
                    <thead class="main-table__header">
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'id', 'ASC')" class="table-header-sort noselect">
                                <span>
                                    Google Ads ID
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                            class="sort-icon sort-icon-desc"
                                            src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'name', 'ASC')" class="table-header-sort noselect">
                                <span>
                                   Google Ads account
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                        class="sort-icon sort-icon-desc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'status', 'ASC')" class="table-header-sort noselect">
                                <span>
                                    Status
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                        class="sort-icon sort-icon-desc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'clicks_count', 'ASC')" class="table-header-sort noselect">
                                <span>
                                    Ad clicks
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                        class="sort-icon sort-icon-desc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'blocked_count', 'ASC')" class="table-header-sort noselect">
                                <span>
                                    Blocked IP
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                        class="sort-icon sort-icon-desc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item">
                            <span @click="sortTable($event, 'budged_saved', 'ASC')" class="table-header-sort noselect">
                                <span>
                                    Saved budget
                                </span>
                                <span class="sort-col-wrapper">
                                    <inline-svg
                                        class="sort-icon sort-icon-desc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                    <inline-svg
                                        class="sort-icon sort-icon-down sort-icon-asc"
                                        src="/images/up-arrow.svg" aria-label="PPCShield">
                                    </inline-svg>
                                </span>
                            </span>
                        </th>
                        <th class="main-table__header-item action-header"></th>
                    </thead>
                    <tbody class="main-table__body">
                        <template v-if="tableData">
                            <template v-if="tableData.length">
                                <tr v-for="item in tableData" class="main-table__row-container">
                                    <td @click="getCampaigns(item.id, item.name)" class="main-table__row-item">{{ item.id }}</td>
                                    <td @click="getCampaigns(item.id, item.name)" class="main-table__row-item">{{ item.name }}</td>
                                    <td @click="getCampaigns(item.id, item.name)">
                                        <div v-if="item.status.toLowerCase() === 'submitted'">
                                            <span class="badge badge-warning" style="font-size: 14px;"
                                                  data-toggle="tooltip" data-placement="bottom" title="Please approve PPC Shield to access your Google Ads account">
                                                Pending
                                            </span>
                                        </div>
                                        <div v-else-if="item.status.toLowerCase() === 'active'">
                                            <span  class="badge badge-success" style="font-size: 14px;">Linked</span>
                                        </div>
                                        <div v-else-if="item.status.toLowerCase() === 'removed'">
                                            <span  class="badge badge-danger" style="font-size: 14px;">Removed</span>
                                        </div>
                                        <div v-else>
                                            <span >{{ item.status }}</span>
                                        </div>
                                    </td>

                                    <template v-if="item.clicks == '0' && item.status.toLowerCase() === 'active'">
                                        <td colspan="3" class="main-table__row-item">
                                            Your account is protected. Waiting for clicks...
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td @click="getCampaigns(item.id, item.name)" class="main-table__row-item">{{ tableNumber(item.clicks) }}</td>
                                        <td @click="getCampaigns(item.id, item.name)" class="main-table__row-item">{{ tableNumber(item.blocks) }}</td>
                                        <template v-if="item.blocks > '0' && item.budged_saved == '0'">
                                            <td class="main-table__row-item">Waiting for CPC from Google Ads</td>
                                        </template>
                                        <template v-else>
                                            <td @click="getCampaigns(item.id, item.name)" class="main-table__row-item">{{ tableCurrency(item.budged_saved) }}</td>
                                        </template>
                                    </template>


                                    <td>
                                        <inline-svg v-bind:id="'select_menu_'+item.id" src="/images/settings-link.svg" class="s-20" aria-label="add"
                                                    v-on:click="event => showSelectMenu(event, 'select_menu_'+item.id)"></inline-svg>
                                        <div class="select-menu for-account">
                                            <div class="select-menu-body">
                                                <div class="select-menu-body-option" v-clipboard:copy="trackingTemplate" v-on:click="(event) => {showModal('tracking-modal'); hideSelectMenu(event,'select_menu_'+item.id);}">
                                                    <inline-svg src="/images/track_changes-24px.svg" class="s-20" aria-label="link"></inline-svg>
                                                    Tracking template
                                                </div>
                                                <div v-bind:class="'select-menu-body-option '+ (item.status === 'REMOVED' ? 'disable' : '')" v-on:click="(event) => {
                                                    if(item.status === 'REMOVED') return;

                                                    /*showModal('remove-unavailable-modal'); return;*/

                                                    forModalAccountObj.g_account_id = item.id;
                                                    forModalAccountObj.g_account_name = item.name;
                                                    showModal('remove-modal');
                                                    hideSelectMenu(event,'select_menu_'+item.id);
                                                }">
                                                    <inline-svg src="/images/link_off-24px.svg" class="s-20" aria-label="link"></inline-svg>
                                                    Remove account
                                                </div>
                                                <div v-bind:class="'select-menu-body-option '+ (item.status === 'REMOVED' ? '' : 'disable')"
                                                     v-on:click="(event) => {
                                                         if(item.status !== 'REMOVED') return;
                                                         hideSelectMenu(event,'select_menu_'+item.id);

                                                         /*showModal('connect-unavailable-modal'); return;*/

                                                         reconnectionAccount(item.id);
                                                    }"
                                                >
                                                    <inline-svg src="/images/link-24px.svg" class="s-20" aria-label="link"></inline-svg>
                                                    Connect account
                                                </div>
                                            </div>
                                            <button class="select-menu-body-hide-button" v-on:click="(event) => {hideSelectMenu(event,'select_menu_'+item.id);}"></button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-else="tableData.length">
                            <tr class="main-table__row-container">
                                <td class="main-table__row-item" colspan="7">Not found</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-else-if="['active', 'trialing', 'past_due'].includes(stripeInfo.subscription_status)">
            <div class="account-no-google-ads">
                <div class="text">
                    <div>
                        Oops, we haven't found any Google Ads accounts connected to our platform. To start protecting your ads, click the button below.
                    </div>
                    <a href="/setup/connectGoogleAds" class="btn btn-primary">
                        CONNECT YOUR GOOGLE ADS
                    </a>
                </div>
                <div class="image"></div>
            </div>
        </template>
        <div style="height: 50px;"></div>
        <modal :height="'auto'" :width="'400px'" name="tracking-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Tracking template
                </div>
                <div class="body">
                    The tracking template has been copied to clipboard
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('tracking-modal')">Close</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="remove-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Remove Google Ads account
                </div>
                <div class="body">
                    Remove {{ forModalAccountObj.g_account_name }} {{ forModalAccountObj.g_account_id }} Google Ads
                    account from PPC Shield? This means PPC Shield will not be able to detect fraudulent clicks and
                    block suspicious IP addresses.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('remove-modal')">DISAGREE</button>
                    <button class="btn" @click="removeAccount()">AGREE</button>
                </div>
            </div>
        </modal>
        <modal name="account-modal">
            <div class="account-modal">
                <div class="modal-header">
                    Add new Account
                </div>
                <div class="modal-body">
                    <form class="account-form">
                        <label class="account-form__label">
                                <span class="account-form__field-title">
                                    Enter Account Number
                                </span>
                            <div class="account-form__field-container">
                                <input class="account-form__field"
                                       v-model="new_account_number"
                                       placeholder="XXX-XXX-XXXX"
                                       v-mask="{mask: '999-999-9999', jitMasking: true, 'autoUnmask': true}"
                                       required
                                />
                            </div>
                        </label>
                    </form>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer__actions actions">
                        <button type="button" class="actions__add-account" @click="hide('account-modal')">Cancel</button>
                        <button type="button" class="actions__add-account" @click="addAccount">Apply</button>
                    </div>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="canceled-unpaid-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Error!
                </div>
                <div class="body">
                    Please activate your subscription to connect Google Ads account {{forModalAccountObj.g_account_id}} to PPC Shield platform
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="selectSubscription">ACTIVATE</button>
                    <button class="btn" @click="hideModal('canceled-unpaid-modal')" style="color: gray;">CLOSE</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="managed-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Error!
                </div>
                <div class="body">
                    The Google Ads account {{forModalAccountObj.g_account_id}} is managed by other PPC Shield user.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('managed-modal')">Close</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="connect-unavailable-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Sorry!
                </div>
                <div class="body">
                    This service is temporary unavailable, please try again later.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('connect-unavailable-modal')">Close</button>
                </div>
            </div>
        </modal>
        <modal :height="'auto'" :width="'400px'" name="remove-unavailable-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Sorry!
                </div>
                <div class="body">
                    This service is temporary unavailable, please try again later or login your Google Ads account, go to Access & Security, click Managers tab and remove PPC Shield access.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('remove-unavailable-modal')">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {accountTable, accountTableTitles} from '../../helpers/account-table';
    import {graphCards, graphOptions, tableNumber, tableCurrency} from '../../helpers/graph-cards';
    import {dateShortCuts, defaultDateRange,setCookiesDateRange, dateToString, stringToDate} from "../../helpers/date-converter";
    import LineChart from './LineChart.js';
    import VueClipboard from 'vue-clipboard2';
    Vue.use(VueClipboard);

    export default {
        name: 'account',
        props: ['user'],
        components: {
            LineChart,
        },
        data: function () {
            return {
                isLoading: false,
                trackingTemplate: '',
                new_account_number: "",
                tableTitles: accountTableTitles(),
                tableData: null,
                tableDataExist: false,
                isLoadingTableData: false,
                graph_type: 'day',
                graphActiveCards: ['saved_budget'],
                accountCards: null,
                filter: {
                    query: '',
                    tags: {},
                    sort: {
                        'column': '',
                        'sort': '',
                    }
                },
                chartData:[],
                chartOptions: graphOptions,
                time: defaultDateRange(),
                shortcuts: dateShortCuts(),
                filtersDataComponent: null,
                disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
                leftDate: "",
                rightDate: "",
                stripeInfo: {subscription_status: ''},

                tableNumber: tableNumber,
                tableCurrency: tableCurrency,

                crutch_for_date_picker: false,

                forModalAccountObj:{g_account_name: '', g_account_id: ''},
            }
        },
        computed: {
            filteredChartData() {
                const datasets = {
                    saved_budget : {
                        label: "Saved Budget",
                        lineTension:0,
                        borderColor: "#3cba54",
                        backgroundColor: "#3cba54",
                        fill: false,
                        data: [],
                        yAxisID: "saved_budget",
                    },
                    ad_clicks : {
                        label: "Ad Clicks",
                        lineTension:0,
                        borderColor: "#4285f4",
                        backgroundColor: "#4285f4",
                        fill: false,
                        data: [],
                        yAxisID: "ad_clicks",
                    },
                    blocked_ip:{
                        label: "Blocked ip",
                        lineTension:0,
                        borderColor: "#dc4b3e",
                        backgroundColor: "#dc4b3e",
                        fill: false,
                        data: [],
                        yAxisID: "blocked_ip",
                    }
                }

                this.chartData.forEach((row) => {
                    this.graphActiveCards.forEach(key => {
                        datasets[key].data.push(row[key]);
                    })
                })

                let dates = this.chartData.map(i => i.date);
                let values = Object.values(datasets).filter(i => i.data.length > 0);
                let start = moment(dates[dates.length-1]);
                const end = moment(this.time[1]);

                while(start < end){
                    switch (this.graph_type) {
                        case 'day' :
                            start.add(1, 'day');
                            break;
                        case 'week' :
                            start.add(1, 'week');
                            break;
                        case 'month' :
                            start.add(1, 'month');
                            break;
                        default: start.add(1, 'day');
                            break;
                    }
                    dates.push(start.format('MMM DD, YYYY'));
                    values.forEach(element => {
                        element.data.push(0);
                    });
                }

                dates = dates.map(i => moment(i).format('MMM DD, YYYY'));

                if (moment(dates[dates.length-1]) > end) {
                    dates.pop();
                }

                this.leftDate = dates[0];
                this.rightDate = dates[dates.length-1];
                dates[0] = "";
                dates[dates.length-1] = "";

                return {
                    labels: dates,
                    datasets: values,
                }
            },
            customFormat() {
                return {
                    stringify: (date) => {
                        if(moment(this.time[1]).format('L') === moment(this.time[0]).format('L')){
                            if(!this.crutch_for_date_picker){
                                this.crutch_for_date_picker = true;
                            }
                            else  {
                                this.crutch_for_date_picker = false;
                            }
                            return date
                                ? this.crutch_for_date_picker
                                    ? moment(date).format('L') === moment(this.time[0]).format('L')
                                        ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                        : ''
                                    : ''
                                : ''
                        }
                        else{
                            return date
                                ? moment(date).format('L') === moment(this.time[0]).format('L')
                                    ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                    : ''
                                : ''
                        }
                    },
                    parse: (value) => {
                        return value
                            ? this.calcDateFormatToDate()
                            : null
                    },
                }
            }
        },
        methods: {
            selectSubscription() {
                window.location.href = '/stripe/selectSubscriptionPlan';
            },
            reconnectionAccount(id) {
                axios.post('/account/reconnect', {
                        google_ads_id: id.replace(/\D/g,'')
                    })
                    .then(info => {
                        if(info.data.error){
                            this.forModalAccountObj.g_account_id = id;

                            if(info.data.error === 'canceled-unpaid'){
                                this.showModal('canceled-unpaid-modal');
                            }
                            else{
                                this.showModal('managed-modal');
                            }
                        }
                        else{
                            window.location.href = '/setup/connectGoogleAds/'+id;
                        }
                    })
                    .catch(err => console.log('err', err));
            },
            removeAccount(){
                this.hideModal('remove-modal');

                axios.post('/account/remove', {
                        google_ads_id: this.forModalAccountObj.g_account_id.replace(/\D/g,'')
                    })
                    .then(info => {
                        if(this.tableData){
                            const acc = this.tableData.filter(item => item.id === this.forModalAccountObj.g_account_id);
                            if(acc.length > 0){
                                acc[0].status = 'REMOVED';
                            }
                        }
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.getAccountData(true);
                    });
            },
            showModal(modal_name) {
                this.$modal.show(modal_name);
            },
            hideModal(modal_name) {
                this.$modal.hide(modal_name);
            },
            showSelectMenu(event, input_id){
                const top = event.target.getBoundingClientRect().top;
                const elem = $('#'+input_id).siblings('.select-menu');
                elem.toggleClass('show', true);
                if(top + elem.height() + 70 > window.innerHeight) elem.css('top', window.innerHeight - elem.height() - 70 +'px');
                else elem.css('top', top+'px');
            },
            hideSelectMenu(event, input_id){
                event.stopPropagation();
                $('#'+input_id).siblings('.select-menu').toggleClass('show', false);
            },
            calcDateFormatToDate(){
                let stringDate = $('.action-header__date-picker .mx-input-wrapper input').val();
                let tempTime = stringToDate(stringDate);
                if(tempTime[0].isValid() &&
                    tempTime[1].isValid() &&
                    (moment(this.time[0]).format('MMM D YYYY') !== moment(tempTime[0]).format('MMM D YYYY') ||
                    moment(this.time[1]).format('MMM D YYYY') !== moment(tempTime[1]).format('MMM D YYYY')))
                {
                    this.time = [tempTime[0].toDate(), tempTime[1].toDate()];
                    this.getChartData();
                }
                return null;
            },
            sortTable(event, column, type) {
                $(".sort-icon").removeClass("active-sort");
                let element = $(event.currentTarget);
                if(column === this.filter.sort.column) {
                    if(this.filter.sort.type === 'ASC') {
                        type = 'DESC';
                        $(element).find(".sort-icon-asc").addClass("active-sort");
                    }
                    else if(this.filter.sort.type === 'DESC') {
                        type = '';
                    }
                    else {
                        type = 'ASC';
                        $(element).find(".sort-icon-desc").addClass("active-sort");
                    }
                } else {
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
                this.filter.sort.column = column;
                if(type === '') this.filter.sort.column = '';
                this.filter.sort.type = type;
                this.getAccountData(true);
            },
            getChartData() {
                axios.get('account/chart',
                    {
                        params: {
                            date_from: this.time[0] ? moment(this.time[0]).format() : '',
                            date_to: this.time[1] ? moment(this.time[1]).format('') : '',
                            chart_type: this.graph_type
                        }
                    })
                    .then(info => {
                        this.chartData = info.data.data;
                        if(this.chartData.length === 1) this.chartData.push(this.chartData[0]);
                        this.accountCards = graphCards(info.data.summary);
                    })
                    .catch(err => console.log('err', err));
            },
            showGraph(graph_id = '') {
                if (graph_id !== '') {
                    const index = this.graphActiveCards.indexOf(graph_id);
                    if (index > -1) {
                        this.graphActiveCards.splice(index, 1);
                    } else {
                        this.graphActiveCards.push(graph_id);
                    }
                }
                $("#account-graph").show();
            },
            clearSearch() {
                this.filter.query = '';
                this.getAccountData(true);
            },
            getAccountData(update = false) {
                const last_search_value = this.filter.query;
                if(this.isLoadingTableData || this.isLoading) return;
                if(update) this.isLoadingTableData = true;
                else this.isLoading = true;
                axios.get('/account/total',
                    {
                        params: {
                            query: this.filter.query,
                            column: this.filter.sort.column,
                            type: this.filter.sort.type,
                            date_from: this.time[0] ? moment(this.time[0]).format() : '',
                            date_to: this.time[1] ? moment(this.time[1]).format() : '',
                            filters: this.filter.tags}
                    })
                    .then(info => {
                        if(update) this.isLoadingTableData = false;
                        else this.isLoading = false;
                        if(last_search_value === this.filter.query){
                            const {data: {items = []}} = info;
                            this.tableData = accountTable(Object.values(items));
                            if(this.tableData && this.tableData.length > 0) this.tableDataExist = true;
                            //init tooltip
                            $(function () {
                                $('[data-toggle="tooltip"]').tooltip()
                            })
                        }
                        else{
                            this.getAccountData(true);
                        }
                    })
                    .catch(err => {
                        if(update) this.isLoadingTableData = false;
                        else this.isLoading = false;
                        console.log('err', err);
                    });
            },
            getStripeInfo(){
                axios.get('/stripe/stripe-info')
                    .then(info => {
                        this.stripeInfo = info.data;
                    });
            },
            getFiltersData() {
                axios.get('/account/totalled')
                    .then(info => {
                        this.filtersDataComponent = info.data.items;
                    })
                    .catch(err => console.log('err', err));
            },
            applyFilter(data) {
                this.filter.tags = data.filter_data;
                this.getAccountData(true);
            },
            addAccount() {
                axios.post('/account/add', {
                    google_ads_id: this.new_account_number
                })
                    .then(info => {
                        this.getAccountData(true);
                        this.hide();
                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
                            this.$notify({
                                group: 'foo',
                                type: 'warn',
                                title: 'Error',
                                text: err.response.data.errors.google_ads_id[0]
                            });
                        }
                    });
            },
            show(modalname) {
                this.$modal.show(modalname);
            },
            hide(modalname) {
                this.$modal.hide(modalname);
            },
            getCampaigns(account_id, campaign) {
                window.location.href = '/campaign?account_id='+account_id.replace(/[^a-zA-Z0-9 ]/g, "")+'&campaign='+campaign;
            },
            setAllTimeDatePicker(){
                axios.get('/account/getStartAllTimeDate')
                .then(response => {
                    this.shortcuts = dateShortCuts(response.data);
                });
            },
            getTrackingTemplate() {
                axios.get('account/getTrackingTemplate')
                    .then(info => {
                        this.trackingTemplate = info.data.data;
                    })
                    .catch(err => console.log('err', err));
            },
        },
        mounted() {
            this.setAllTimeDatePicker();
            this.getAccountData();
            this.getStripeInfo();
            this.getFiltersData();
            this.getChartData();
            this.getTrackingTemplate();
        },
        watch: {
            time: function(val) {
                setCookiesDateRange(val[0], val[1]);
                this.getAccountData(true);
            },
            graph_type: function () {
                this.getChartData();
            }
        }
    }
</script>
